// Het teken van Marvin: een tekstballon met twee ogen (de assistent die meedenkt). Gekozen 16-10-2026.
// Eén bron (lib/marvin-teken.ts) voor zijbalk, berichten, logboek, inlogpagina, browser- en app-icoon en InServe-notities.
import { BALLON, OGEN } from '@/lib/marvin-teken'
export { MINT, INKT } from '@/lib/marvin-teken'

// Kleur volgt de tekstkleur (currentColor), tenzij je er een meegeeft
export function MarvinTeken({ size = 16, className, kleur, dikte = 2 }: { size?: number; className?: string; kleur?: string; dikte?: number }) {
  const k = kleur ?? 'currentColor'
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={k} strokeWidth={dikte} strokeLinecap="round" strokeLinejoin="round" className={className} aria-hidden="true">
      <path d={BALLON} />
      {OGEN.map(([x, y]) => <circle key={x} cx={x} cy={y} r={1.35} fill={k} stroke="none" />)}
    </svg>
  )
}
